import toast from "react-hot-toast";

const ViaqTryCatch = async (method) => {
    try {
        const response = await method();

        const value = {
            success: true,
            message: response.status.message,
            statusCode: response.status.code,
            data: response.data
        };
        // console.log("RETURN SUCCESS VALUE : ",value);
        return value;

    } catch (e) {

        if (e.code === -3) {
          // console.log("ERROR -3 COMEEEEEEEEEEEEEEEEEEEE:", e);

            toast.error("لطفا دوباره وارد شوید");

            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            return window.location.replace("/");
        } else if (e.code === 77) {
          // console.log("ERROR 77 COMEEEEEEEEEEEEEEEEEEEE:", e);
            toast.error("لطفا دوباره وارد شوید");
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            // return window.location.replace("/");
        }
        const value = {success: false, message: e.message, statusCode: e.code};
      // console.log("CATCH ERROR VALUE : ", e);
      // console.log("RETURN ERROR VALUE : ", value);
        return value;

    }
}
export default ViaqTryCatch;